import { FormFactor } from '../types';

// Largest board first
const boardOrder: FormFactor[] = ['E-ATX', 'ATX', 'Micro-ATX', 'Mini-DTX', 'Mini-ITX'];

const rank = (ff: FormFactor): number => {
  const index = boardOrder.indexOf(ff);
  return index === -1 ? boardOrder.length : index;
};

export const sortFormFactors = (supported: FormFactor[]): FormFactor[] =>
  [...supported].sort((a, b) => rank(a) - rank(b));

export const getLargestBoard = (supported: FormFactor[]): FormFactor | undefined =>
  sortFormFactors(supported)[0];
